// Branch.js

class Branch {
    constructor(id, name) {
        this.id = id;
        this.name = name;
    }
}

const branches = [
    new Branch(1003, 'Eastgate'),
    new Branch(1004, 'Kwame Nkrumah'),
    new Branch(1005, 'Joina City'),
    new Branch(1006, 'Avondale'),
    new Branch(1007, 'Diaspora Banking'),
    new Branch(1008, 'Mutare'),
    new Branch(1009, 'Gweru'),
    new Branch(1010, 'Bulawayo'),
    new Branch(1011, 'Masvingo'),
    new Branch(1012, 'Millenial Club'),
    new Branch(1013, 'Platinum'),
    new Branch(1014, 'Borrowdale Platinum'),
    new Branch(1015, 'Victoria Falls'),
    new Branch(1016, 'Bradfield')
];

export { Branch, branches };